import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DashboardService } from '../../_services/dashboard.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import moment from 'moment';
declare var $: any;


@Component({
  selector: 'app-students-dismissal-tracking-log',
  templateUrl: './students-dismissal-tracking-log.component.html',
  styleUrls: ['./students-dismissal-tracking-log.component.scss']
})
export class StudentsDismissalTrackingLogComponent implements OnInit {
  logType: any;
  loading = true;
  currLang;
  tableControls;
  sub;
  controlType = 'tracking-log';
  reportFilter;
  dataArray;
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number;
  lastPage: number;
  perPage: number = 4;

  constructor(private _ActivatedRoute: ActivatedRoute, private _router: Router, private globalService: GlobalService,
    private translate: TranslateService, private dashboardService: DashboardService, private errorMsgService: ErrorMsgService) {
    this.logType = _ActivatedRoute.snapshot.params.type;
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.sub = new Subscription();
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.currentPage = 1;
    let x = this.dashboardService.getReportFilter().subscribe((res: any) => {
      // this.loading = false;
      this.currentPage = 1;
      if (res !== null) {
        this.reportFilter = res;
        this.reportFilter.dismissalStatus ? this.reportFilter.dismissalStatus = this.reportFilter.dismissalStatus : this.reportFilter.dismissalStatus = this.logType;
        // this.reportFilter.dismissalType ? this.reportFilter.dismissalType = this.reportFilter.dismissalType : this.reportFilter.dismissalType = 'flow';
        // to remove double quotes and backslaches when JSON.stringify is called multiple times 
        // this.reportFilter.dismissal = this.reportFilter.dismissal.replace(/\\/g, '');
        // this.reportFilter.dismissal = this.reportFilter.dismissal.replaceAll("\"", "");
        this.getDismissalStudentsFlowReport();
        this.setTableControls();
      }
    })
    this.sub.add(x);
  }

  back() {
    this._router.navigateByUrl('/reports/dashboard');
  }

  exportToExcelFile() {

  }

  generateExcelFile() {
    this.dashboardService.generateExcelFile(this.reportFilter).subscribe(res => {
    })
  }

  viewStudent(student) {
    this.dashboardService.getStudentDismissalById(student.id, this.reportFilter, 1, this.perPage).subscribe(res => {
      student['dismissalHistory'] = res;
      student["filter"] = this.reportFilter;
      this.dashboardService.setStudentData(student, 'view');
    },
      err => {
        this.errorMsgService.setMessage(err.error.message);
      },
      () => {
        $("#viewStudentModal").modal("show");
        this.scrollContentTop('#viewStudentModal');
      })
  }

  // to fix cashed scroll after opening and closing of modal for the same user (view , edit)
  scrollContentTop(modalName) {
    $(`${modalName} .modal-body`)[0].scrollTop = 0;
  }

  paginationHandling(event) {
    this.currentPage += event.dir;
    this.getDismissalStudentsFlowReport();
  }
  tableEventHandeler(event) {
    switch (event.action) {
      case "rowClicked":
        this.viewStudent(event.target.data);

        break;
      // case "iconClicked":
      //   switch (this.listType) {
      //     case "students":
      //       this.editStudent(event.e,event.target.data);
      //       break;
      //       case "parents":
      //         this.editParent(event.e,event.target.data);
      //         break;
      //      }
      // break;
      // case "checkboxChanged":
      //   this.selectChanged(event.target);
      //   break;
      // case "sorting":
      //   this.toggleSorting(event.target.source);
      //   break;
      case "pagination":
        this.paginationHandling(event.target);
        break;

    }
  }
  initColumsByLogType() {
    let columns = [];
    switch (this.logType) {
      case 'not_requested':
        columns = [
          {
            name: "",
            sort: false,
            type: "image",
            source: "image_path"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-name'),
            sort: false,
            type: "string",
            source: "name"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-id'),
            sort: false,
            type: "string",
            source: "national_id"
          },
          {
            name: this.translate.instant('dismissal-flowlog.grade'),
            sort: false,
            type: "string",
            source: "gradeName"
          },
          {
            name: this.translate.instant('dismissal-flowlog.class'),
            sort: false,
            type: "string",
            source: `clazzName`
          },
          {
            name: this.translate.instant('dismissal-flowlog.Request-status'),
            sort: false,
            type: "string",
            source: "status_name"
          },
        ]
        break;
      case 'pending':
        columns = [
          {
            name: "",
            sort: false,
            type: "image",
            source: "image_path"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-name'),
            sort: false,
            type: "string",
            source: "name"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-id'),
            sort: false,
            type: "string",
            source: "national_id"
          },
          {
            name: this.translate.instant('dismissal-flowlog.grade'),
            sort: false,
            type: "string",
            source: "gradeName"
          },
          {
            name: this.translate.instant('dismissal-flowlog.class'),
            sort: false,
            type: "string",
            source: `clazzName`
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-time'),
            sort: false,
            type: "string",
            source: "formated_request_at"
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-by'),
            sort: false,
            type: "string",
            source: "requested_by"
          },
          {
            name: this.translate.instant('dismissal-flowlog.role'),
            sort: false,
            type: "string",
            source: "requested_by_role",
            translateRole: true
          },
          {
            name: this.translate.instant('dismissal-flowlog.Request-status'),
            sort: false,
            type: "string",
            source: "status_name"
          },
        ]

        break;
      case 'with_staff':
        columns = [
          {
            name: "",
            sort: false,
            type: "image",
            source: "image_path"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-name'),
            sort: false,
            type: "string",
            source: "name"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-id'),
            sort: false,
            type: "string",
            source: "national_id"
          },
          {
            name: this.translate.instant('dismissal-flowlog.grade'),
            sort: false,
            type: "string",
            source: "gradeName"
          },
          {
            name: this.translate.instant('dismissal-flowlog.class'),
            sort: false,
            type: "string",
            source: `clazzName`
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-time'),
            sort: false,
            type: "string",
            source: "formated_request_at"
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-by'),
            sort: false,
            type: "string",
            source: "requested_by"
          },
          {
            name: this.translate.instant('dismissal-flowlog.role'),
            sort: false,
            type: "string",
            source: "requested_by_role",
            translateRole: true
          },
          {
            name: this.translate.instant('dismissal-flowlog.Request-status'),
            sort: false,
            type: "string",
            source: "status_name"
          },
        ]
        break;
      case 'all_delivered':
        columns = [
          {
            name: "",
            sort: false,
            type: "image",
            source: "image_path"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-name'),
            sort: false,
            type: "string",
            source: "name"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-id'),
            sort: false,
            type: "string",
            source: "national_id"
          },
          {
            name: this.translate.instant('dismissal-flowlog.grade'),
            sort: false,
            type: "string",
            source: "gradeName"
          },
          {
            name: this.translate.instant('dismissal-flowlog.class'),
            sort: false,
            type: "string",
            source: `clazzName`
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-time'),
            sort: false,
            type: "string",
            source: "formated_request_at"
          },
          {
            name: this.translate.instant('dismissal-flowlog.deliver-time'),
            sort: false,
            type: "string",
            source: "formated_delivered_at"
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-by'),
            sort: false,
            type: "string",
            source: "requested_by"
          },
          {
            name: this.translate.instant('dismissal-flowlog.role'),
            sort: false,
            type: "string",
            source: "requested_by_role",
            translateRole: true
          },
          {
            name: this.translate.instant('dismissal-flowlog.delivered-by'),
            sort: false,
            type: "string",
            source: "delivered_by"
          },
          {
            name: this.translate.instant('dismissal-flowlog.Request-status'),
            sort: false,
            type: "string",
            source: "status_name"
          },
        ]
        break;
      case 'canceled':
        columns = [
          {
            name: "",
            sort: false,
            type: "image",
            source: "image_path"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-name'),
            sort: false,
            type: "string",
            source: "name"
          },
          {
            name: this.translate.instant('dismissal-flowlog.student-id'),
            sort: false,
            type: "string",
            source: "national_id"
          },
          {
            name: this.translate.instant('dismissal-flowlog.grade'),
            sort: false,
            type: "string",
            source: "gradeName"
          },
          {
            name: this.translate.instant('dismissal-flowlog.class'),
            sort: false,
            type: "string",
            source: `clazzName`
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-time'),
            sort: false,
            type: "string",
            source: "formated_request_at"
          },
          {
            name: this.translate.instant('dismissal-flowlog.request-by'),
            sort: false,
            type: "string",
            source: "requested_by"
          },
          {
            name: this.translate.instant('dismissal-flowlog.role'),
            sort: false,
            type: "string",
            source: "requested_by_role",
            translateRole: true
          },
          {
            name: this.translate.instant('dismissal-flowlog.Request-status'),
            sort: false,
            type: "string",
            source: "status_name"
          },
        ]
        break;
    }
    return columns;
  }

  getDismissalStudentsFlowReport() {
    this.loading = true;
    this.dashboardService.getDismissalStudentsFlowReport(this.reportFilter, this.currentPage).subscribe((res: any) => {
      res.data.forEach(element => {
        element.clazzName = element.class.name
        element.gradeName = element.class.grade.name
        
        element.formated_request_at = moment(element.requested_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A')
        element.formated_delivered_at = moment(element.delivered_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A')
        // element.formated_request_at = this.formatDate(element.requested_at)
        // element.formated_delivered_at = this.formatDate(element.delivered_at)
        element.originalStatus = element.status_name
        element.status_name = this.localizeStatus(element.status_name)
        // element.formated_request_at=this.formatDate(element.created_at)
        // element.formated_delivered_at=this.formatDate(element.created_at)
      });
      this.from = res.from;
      this.to = res.to;
      this.total = res.total;
      this.lastPage = res.last_page;
      this.dataArray = res.data;
      this.translate.get('init').subscribe(res => {
        this.setTableControls();
      });
      this.translate.onLangChange.subscribe(res => {
        this.currLang = res.lang;
        this.dataArray.forEach(element => {
          element.formated_request_at = moment(element.requested_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A')
          element.formated_delivered_at = moment(element.delivered_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A')
          element.status_name = this.localizeStatus(element.originalStatus)
        })
        this.setTableControls();
      });
      this.stopLoading();
    })
  }
  setTableControls() {
    this.tableControls = {
      selection: false,
      paging: true,
      view: 'list',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: this.initColumsByLogType(),
      data: this.dataArray
    }
  }
  formatDate(_date) {
    if (_date != null) {
      let date = new Date(_date);
      let formatedDate = date.toLocaleString('en-GB',
        {
          hour12: true,

          hour: '2-digit',
          minute: '2-digit'
        });
      formatedDate = formatedDate.replace(',', "");
      return formatedDate.toUpperCase()
    }

  }

  stopLoading() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  localizeStatus(_status) {
    let localizedStatus;

    switch (_status) {
      case "not_requested":
        localizedStatus = this.currLang == "en" ? "not requested" : "لم يتم طلبه";
        break;
      case "delivered":
        localizedStatus =
          this.currLang == "en" ? "Delivered" : "تم تسليمه";
        break;
      case "pending":
        localizedStatus = this.currLang == "en" ? "pending" : "قيد الانتظار ";
        break;

      case "with_supervisor":
        localizedStatus =
          this.currLang == "en" ? "with supervisor" : "مع المشرف";
        break;
      case "with_teacher":
        localizedStatus = this.currLang == "en" ? "with teacher" : "مع المعلم";
        break;
      case "with_security":
        localizedStatus = this.currLang == "en" ? "with security" : "مع الحارس";
        break;

      case "with_parent":
        localizedStatus =
          this.currLang == "en" ? "with parent" : "مع ولي الأمر";
        break;
      case "delivered_flow":
        localizedStatus = this.currLang == "en" ? "delivered" : "تم تسليمه";
        break;
      case "pending_flow":
        localizedStatus = this.currLang == "en" ? "pending" : "قيد الانتظار ";
        break;

      case "with_supervisor_flow":
        localizedStatus = this.currLang == "en" ? "with supervisor" : "مع المشرف";
        break;
      case "with_teacher_flow":
        localizedStatus = this.currLang == "en" ? "with teacher" : "مع المعلم";
        break;
      case "with_security_flow":
        localizedStatus = this.currLang == "en" ? "with security" : "مع الحارس";
        break;

      case "with_parent_flow":
        localizedStatus = this.currLang == "en" ? "with parent" : "مع ولي الأمر";
        break;
      case "delivered_qr":
        localizedStatus = this.currLang == "en" ? "delivered QR code" : "QR تم تسليمه كود";
        break;
      case "pending_qr":
        localizedStatus = this.currLang == "en" ? "pending QR code" : "QR قيد الانتظار كود";
        break;
      case "with_supervisor_qr":
        localizedStatus = this.currLang == "en" ? "with supervisor QR code" : "QR مع المشرف كود";
        break;
      case "with_teacher_qr":
        localizedStatus = this.currLang == "en" ? "with teacher QR code" : "QR مع المعلم كود";
        break;

      case "with_security_qr":
        localizedStatus = this.currLang == "en" ? "with security QR code" : "QR مع الحارس كود";
        break;
      case "with_parent_qr":
        localizedStatus = this.currLang == "en" ? "with parent QR code" : "QR مع ولى الأمر كود";
        break;
      case "picked_from_school":
        localizedStatus = this.currLang == "en" ? "picked from school" : "خرج من المدرسة";
        break;
      case "dropped_at_home":
        localizedStatus = this.currLang == "en" ? "delivered" : "تم تسليمه";
        break;
      case "canceled":
        localizedStatus = this.currLang == "en" ? "canceled" : "تم إلغاؤه";
        break;
    }
    return localizedStatus
  }

}
